var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9095 11.4545H11.455C5.1284 11.4545 0 6.32615 0 0H11.4545C17.7807 0 22.9091 5.1284 22.9091 11.4545H22.9095ZM34.3641 4.96339C28.0379 4.96339 22.9095 10.0918 22.9095 16.4179H30.5459C36.872 16.4179 42.0004 11.2895 42.0004 4.96339H34.3641ZM18.2297 19.8868V24.0211H21.8772C22.0873 24.0211 22.2589 24.193 22.2589 24.4028C22.2589 24.6125 22.0869 24.7845 21.8772 24.7845H18.2297V28.1869H20.7316C20.9417 28.1869 21.1133 28.3589 21.1133 28.5686C21.1133 28.7784 20.9413 28.9504 20.7316 28.9504H18.2297V32.6388H19.5863C19.7965 32.6388 19.9681 32.8108 19.9681 33.0206C19.9681 33.2307 19.7961 33.4023 19.5863 33.4023H18.2297V39.2219C18.2297 40.7563 19.4735 42 21.0078 42C22.5421 42 23.7859 40.7563 23.7859 39.2219V19.8864C23.7859 18.2252 24.4365 17.5631 24.4365 17.5631H17.5636C17.5636 17.5631 18.2297 18.2847 18.2297 19.8864V19.8868Z",
    fill: "#051836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.17308277d474a457d489490689c0f89d.svg";
export { ForwardRef as ReactComponent };